export function timer() {
    let timer = $('.holder-timer');
    if (timer.length > 0) {
        $('.landing-banner.haircolor').addClass('has-timer');
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/timer.js